<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card class="mx-auto text-start">
          <v-img
            class="white--text align-end"
            src="../../resources/household_bg.png"
          ></v-img>
          <v-card-title v-if="household">{{ household.name }}</v-card-title>
          <v-card-subtitle class="text-start">{{ address }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-auto text-start">
          <v-btn fab color="primary" @click="dialog = true" top right absolute>
            <v-icon>add</v-icon>
          </v-btn>
          <v-list two-line subheader>
            <v-subheader inset>Guests</v-subheader>
            <v-list-item v-for="member in guests" :key="member.id">
              <v-list-item-avatar
                :color="member.color !== 'white' ? member.color : '#F5F5F5'"
                :class="
                  member.color !== 'white' ? 'white--text' : 'black--text'
                "
                v-text="member.initials"
              ></v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="member.firstName + ' ' + member.lastName"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="member.licensePlate"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <!-- <v-btn icon>
                <v-icon small color="red">fas fa-info</v-icon>
                </v-btn>-->
                <v-list-item-action-text>Active</v-list-item-action-text>
                <v-switch
                  v-model="member.active"
                  @change="activateMember($event, member)"
                  color="primary"
                ></v-switch>
              </v-list-item-action>
              <v-list-item-action>
                <v-list-item-action-text>Remove</v-list-item-action-text>
                <v-btn icon @click="deleteMember(member)" color="secondary">
                  <v-icon small>fas fa-trash</v-icon>
                </v-btn>
                <delete-confirmation
                  type="members"
                  item="member"
                  :id="member.id"
                  :message="member.firstName + ' was removed'"
                  :dialog="deleteDialog"
                />
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list two-line subheader>
            <v-subheader inset>Members</v-subheader>
            <v-list-item v-for="member in members" :key="member.id">
              <v-list-item-avatar
                :color="member.color"
                :class="
                  member.color !== 'white' ? 'white--text' : 'black--text'
                "
                v-text="member.initials"
              ></v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="member.firstName + ' ' + member.lastName"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="member.licensePlate"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text>Remove</v-list-item-action-text>
                <v-btn icon @click="deleteMember(member)" color="secondary">
                  <v-icon small>fas fa-trash</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
        <v-dialog v-model="dialog" max-width="650px">
          <v-form ref="newMember" lazy-validation>
            <v-card class="mx-auto text-start padding-20">
              <v-card-title>Add Member</v-card-title>
              <v-card-subtitle v-if="household">{{
                household.name
              }}</v-card-subtitle>
              <v-card-text clas="padding-20">
                <v-layout>
                  <v-radio-group v-model="newMember.guest" row>
                    <v-radio label="Resident" color="primary"></v-radio>
                    <v-radio label="Guest" :value="true"></v-radio>
                  </v-radio-group>
                </v-layout>
                <v-text-field
                  required
                  v-model="newMember.firstName"
                  label="First Name"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  required
                  v-model="newMember.lastName"
                  label="Last Name"
                  outlined
                ></v-text-field>
                <v-text-field
                  required
                  v-model="newMember.licensePlate"
                  label="Tag"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>

                <v-select
                  v-model="newMember.color"
                  outlined
                  :items="colors"
                  label="Car Color"
                >
                  <template v-slot:selection="data">
                    <v-icon :color="data.item">fas fa-circle</v-icon>
                    <span class="padding-10">{{ data.item }}</span>
                  </template>
                  <template v-slot:item="data">
                    <v-icon :color="data.item">fas fa-circle</v-icon>
                    <span class="padding-10">{{ data.item }}</span>
                  </template>
                </v-select>
                <v-text-field
                  required
                  v-model="newMember.carModel"
                  label="Car Model"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
                <v-text-field
                  required
                  v-model="newMember.carYear"
                  label="Year"
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="addMember">Submit</v-btn>
                <v-btn
                  color="error"
                  text
                  @click="
                    dialog = false;
                    $refs.newMember.reset();
                  "
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <!-- <v-dialog v-model="activateGuestDialog" max-width="500px">
        <v-card>
          <v-card-title>Activate Guest</v-card-title>
          <v-card-text>
            <label>How many days would you like it to remain active?</label>
            <v-text-field
              required
              v-model="visitor.permitDays"
              type="number"
              :rules="requiredRules"
              outlined
              color="accent"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="error" text @click="activateGuestDialog = false">Close</v-btn>
            <v-btn color="accent" text @click="activateMember()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>-->
        <v-snackbar
          v-model="snackbar"
          color="info darken-1"
          :timeout="3000"
          light
          top
        >
          {{ snackbarMessage }}
          <v-btn text @click="snackbar = false" to="/household">Close</v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { householdsRef } from "../../firebaseApp";
import householdObject from "../json/household.json";
import {
  firebaseApp,
  membersRef,
  householdsRef,
  visitorsRef,
} from "../../firebaseApp";
import memberObject from "../json/member.json";
import visitorObject from "../json/visitor.json";
import colorsOptions from "../json/colors.json";
import DeleteConfirmation from "../members/DeleteConfirmation.vue";

export default {
  components: { DeleteConfirmation },
  data: () => ({
    dialog: false,
    deleteDialog: "no",
    alert1: false,
    activateGuestDialog: false,
    snackbar: false,
    snackbarMessage: "",
    colors: colorsOptions,
    requiredRules: [(v) => !!v || "Required"],
    household: householdObject,
    member: memberObject,
    currentMember: {},
    members: [],
    guests: [],
    newMember: memberObject,
    visitor: visitorObject,
    alert: {
      type: "error",
      message: "",
    },
    items: [
      {
        icon: "LV",
        iconClass: "accent white--text",
        title: "Linda Ventura",
        subtitle: "Jan 9, 2019",
      },
      {
        icon: "JA",
        iconClass: "accent white--text",
        title: "Jorge Astorgas",
        subtitle: "Jan 9, 2019",
      },
      {
        icon: "ES",
        iconClass: "accent white--text",
        title: "Evist Del Sol",
        subtitle: "Jan 9, 2019",
      },
      {
        icon: "RA",
        iconClass: "accent white--text",
        title: "Renzo Apellido",
        subtitle: "Jan 9, 2019",
      },
    ],
  }),
  watch: {},
  computed: {
    address: function () {
      if (this.household)
        return this.household.aptNumber + " " + this.household.streetName;
      else return "";
    },
    newMemberFullName: function () {
      if (this.newMember)
        return this.newMember.firstName + " " + this.newMember.lastName;
      else return "";
    },
  },
  methods: {
    loadMemberInfo() {
      this.member = this.$store.state.member;
      this.members = [];
      this.guests = [];
      let householdKey = this.member.householdKey;
      this.loadHousehold(householdKey);
      membersRef.on("value", (snap) => {
        let householdMembers = [],
          householdGuests = [];
        snap.forEach((member) => {
          if (member.val().householdKey == householdKey) {
            if (member.val().guest) {
              let resident = this.formatMember(member);
              householdGuests.push(resident);
            } else {
              let guest = this.formatMember(member);
              householdMembers.push(guest);
            }
          }
        });
        this.members = householdMembers;
        this.guests = householdGuests;
      });
    },
    activateMember(event, member) {
      //this.activateGuestDialog = true;
      var today = new Date();
      var tomorrow = today.setHours(today.getHours() + 24);
      var expirationDate = tomorrow;
      this.updateActiveStatus(member, event, expirationDate);
      let visitor = {};
      visitor.dateAdded = Date.now();
      visitor.memberKey = member.id;
      visitor.expirationDate = expirationDate;
      visitor.licensePlate = member.licensePlate;
      visitor.householdKey = member.householdKey;
      visitor.communityCode = member.communityCode;
      visitor.carModel = member.carModel;
      visitor.carYear = member.carYear;
      visitor.color = member.color;
      visitor.name = member.firstName + " " + member.lastName;
      visitor.unit = this.household.aptNumber;
      visitorsRef.push(visitor).key;
    },
    isMemberActive(member) {
      var expirationDate = member.expirationDate;
      if (member.active == true && expirationDate > Date.now()) return true;
      else return false;
    },
    updateActiveStatus(member, status, expirationDate) {
      firebaseApp
        .database()
        .ref("/members/" + member.id)
        .update({ active: status, expirationDate: expirationDate })
        .then(
          (this.snackbar = true),
          (this.snackbarMessage =
            member.firstName + " is now an active visitor")
        );
    },
    deleteMember(member) {
      //var memberName = member.firstName;
      if (member.email == "") {
        this.deleteDialog = "open";
        // firebaseApp
        //   .database()
        //   .ref("/members/" + member.id)
        //   .remove()
        //   .then(
        //     (this.snackbar = true),
        //     (this.snackbarMessage = memberName + " was removed")
        //   );
      } else {
        this.snackbar = true;
        this.alert1 = true;
        this.snackbarMessage =
          "You cannot delete this member because it is associate to this user's account";
      }
    },
    loadHousehold(householdKey) {
      householdsRef.on("value", (snap) => {
        snap.forEach((household) => {
          if (household.key == householdKey) {
            let hh = {};
            hh = household.val();
            hh.id = household.key;
            this.household = hh;
          }
        });
      });
    },
    formatMember(member) {
      let formattedMember = {};
      formattedMember = member.val();
      formattedMember.id = member.key;
      formattedMember.active = this.isMemberActive(member.val());
      formattedMember.initials =
        formattedMember.firstName.charAt(0) +
        formattedMember.lastName.charAt(0);
      formattedMember.color = formattedMember.color
        ? formattedMember.color
        : "lime";
      return formattedMember;
    },
    addMember() {
      if (this.$refs.newMember.validate()) {
        this.newMember.dateAdded = Date.now();
        this.newMember.email = "";
        this.newMember.communityCode = this.member.communityCode;
        this.newMember.householdKey = this.member.householdKey;
        this.newMember.id = membersRef.push(this.newMember).key;
        this.snackbar = true;
        this.snackbarMessage =
          this.newMemberFullName + " was successfully added";
        this.activateMember(true, this.newMember);
        this.dialog = false;
        this.$refs.newMember.reset();
      }
    },
  },
  mounted() {
    this.loadMemberInfo();
  },
  created() {},
};
</script>